import React from 'react';
import PageBackSection from './PageBackSection';

/**
 * Distinct page header block — title, optional actions, and toolbar slot.
 * When showBack is true, back navigation renders in PageBackSection above the hero card.
 */
export default function PageHeaderSection({
  title,
  subtitle,
  eyebrow,
  aside,
  children,
  backTo = null,
  showBack = true,
  className = '',
}) {
  const hero = (
    <section className={`page-hero-section ${className}`.trim()}>
      <div className="page-hero-card">
        <div className="page-hero-main">
          <div className="page-hero-heading">
            {eyebrow && <p className="page-hero-eyebrow">{eyebrow}</p>}
            <h1 className="page-hero-title">{title}</h1>
            {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
          </div>
          {aside && <div className="page-hero-aside">{aside}</div>}
        </div>

        {children && <div className="page-hero-toolbar">{children}</div>}
      </div>
    </section>
  );

  if (!showBack) {
    return hero;
  }

  return (
    <div className="page-top-stack">
      <PageBackSection backTo={backTo} />
      {hero}
    </div>
  );
}
